import { render, staticRenderFns } from "./invoice_details.vue?vue&type=template&id=c5944aaa&scoped=true&"
import script from "./invoice_details.vue?vue&type=script&lang=js&"
export * from "./invoice_details.vue?vue&type=script&lang=js&"
import style0 from "./invoice_details.vue?vue&type=style&index=0&id=c5944aaa&prod&lang=scss&scoped=true&"
import style1 from "./invoice_details.vue?vue&type=style&index=1&id=c5944aaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5944aaa",
  null
  
)

export default component.exports